<template>
  <div>
    <headPage></headPage>
    <div style="border-bottom: 1px solid #eee; margin-bottom: 10px"></div>
    <div class="left_title">
      <span @click="gobidbond">保函列表</span> > 保函详情
    </div>
    <div style="padding: 20px 0; width: 600px; margin: 0 auto">
      <el-steps :active="isPage">
        <el-step title="项目相关信息" description=""></el-step>
        <el-step title="等待审核" description=""></el-step>
        <el-step title="付款并提供签约资料" description=""></el-step>
        <el-step title="保函开立" description=""></el-step>
      </el-steps>
    </div>
    <div class="applyFor" v-loading="dataLoading">
      <div
        v-if="formModel.status == '99'"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          padding: 10px 0;
        "
      >
        <i
          style="font-size: 26px; margin-right: 10px"
          class="el-icon-document"
        ></i>
        <p>您提交的信息正在审核中，请耐心等待</p>
      </div>
      <el-form
        style="background: #fff"
        ref="form"
        size="small"
        :model="formModel"
        class="demo-ruleForm"
      >
        <div
          style="
            line-height: 40px;
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
            font-weight: 700;
          "
        >
          订单信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="订单状态：">
              <span class="el_item_text">{{ formModel.statusName }}</span>
              <el-button
                class="optButton"
                type="primary"
                v-if="formModel.status === '03'"
                @click="applyInvoice"
                >申请开票</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formModel.status != '99'">
            <el-form-item label="付款金额（人民币）：">
              <span class="el_item_text"
                >{{ formModel.guaranteePayMoney || '--' }}
                元
                <span>{{
                  formModel.isSubmitPayVoucher ? ' （ 已提交 ）' : ''
                }}</span></span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请时间：">
              <span class="el_item_text">{{ formModel.created }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函性质：">
              <span class="el_item_text">{{
                formModel.guaranteeTypeName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出函机构：">
              <span class="el_item_text">{{
                formModel.returnGuaranteeOrgName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函分类：">
              <span class="el_item_text">{{
                formModel.guaranteeCategoryName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款凭证：">
              <span
                v-if="
                  (formModel.status === '02' ||
                    formModel.status === '03' ||
                    formModel.status === '04' ||
                    formModel.status === '05' ||
                    formModel.status === '06') &&
                  formModel.isSubmitPayVoucher
                "
                class="el_item_text"
                >（ 已提交 ）</span
              >
              <el-button
                class="optButton"
                v-if="formModel.status === '00'"
                type="primary"
                @click="etplegaPayClick"
                >{{
                  formModel.isSubmitPayVoucher ? '已提交/去编辑' : '去提交'
                }}</el-button
              >
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="签约资料：">
              <span
                v-if="
                  (formModel.status === '03' ||
                    formModel.status === '04' ||
                    formModel.status === '05' ||
                    formModel.status === '06') &&
                  formModel.isFixSignDocs
                "
                class="el_item_text"
                >（ 已提交 ）</span
              >
              <!-- 去编辑 -->
              <el-button
                v-if="formModel.status === '00' || formModel.status === '02'"
                class="optButton"
                type="primary"
                @click="signUploadBtn"
                >{{
                  formModel.isFixSignDocs ? '已提交/去编辑' : '去提交'
                }}</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formModel.status == '00'">
            <div style="border: 1px solid #eee; padding: 8px">
              <p>收款账户：北京银保慧通科技有限公司</p>
              <p>账号：110943409410902</p>
              <p>开户行：招商银行股份有限公司北京西二旗支行</p>
            </div>
          </el-col>
        </el-row>
        <div
          style="
            border-bottom: 1px solid #eee;
            font-weight: 700;
            margin-bottom: 10px;
            padding: 10px 0;
          "
        >
          投标企业信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称：">
              {{ formModel.etpName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社会信用代码：">
              {{ formModel.etpUscc }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注册资本：">
              {{ formModel.etpRegCapital || '--' }}万元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业：">
              {{ formModel.etpIndustryName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业性质：">
              {{ formModel.etpPropertyName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册地址：">
              {{ formModel.etpAddrFullName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件签发日期：">
              {{
                formModel.etpCertBeginDate + ' 至 ' + formModel.etpCertEndDate
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="1"
                  v-model="formModel.etpIdcard"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          style="
            border-bottom: 1px solid #eee;
            font-weight: 700;
            margin-bottom: 10px;
            padding: 10px 0;
          "
        >
          法人信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="法人姓名：">
              {{ formModel.etpLegal }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人证件类型："> 身份证 </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="法人身份证号：">
              {{ fixIdCard(formModel.etpLegalIdcardCode) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证有效期：">
              {{ formModel.etpLegalIdcardDateBegin }} -
              {{ formModel.etpLegalIdcardDateEnd }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人手机号：">
              {{ formModel.etpLegalPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人正面证件照：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="2"
                  v-model="formModel.etpLegalIdcardPicZm"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人背面证件照：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="3"
                  v-model="formModel.etpLegalIdcardPicFm"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          style="
            border-bottom: 1px solid #eee;
            font-weight: 700;
            margin-bottom: 10px;
            padding: 10px 0;
          "
        >
          项目信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称：">
              <span class="el_item_text">{{ formModel.projectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目编号：">
              <span class="el_item_text">{{ formModel.projectCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="担保金额（人民币）：">
              <span class="el_item_text">
                {{
                  formatCurrency(Number(formModel.guaranteeMoney)) || '--'
                }}元</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函受益人(甲方/招标放名称)：">
              <span class="el_item_text">{{ formModel.bidCompanyName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办人姓名：">
              <span class="el_item_text">{{ formModel.operator }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经办人手机号：">
              <span class="el_item_text">{{ formModel.operatorPhone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函有效期：">
              <span v-if="formModel.guaranteeDays" class="el_item_text"
                >{{ formModel.guaranteeDays / 30 }}个月</span
              >
              <span v-else class="el_item_text">{{
                formModel.guaranteeEndDate
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函邮寄地址：">
              {{ formModel.guaranteePostAddrFullName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递公司名称：">
              {{ formModel.guaranteePostType }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号：">
              {{ formModel.guaranteePostCode }}
            </el-form-item>
          </el-col>
          <el-col v-if="formModel.guaranteeDocument == '03'" :span="12">
            <el-form-item style="margin-top: -15px">
              <div
                style="display: flex; align-items: center; margin-top: -25px"
              >
                <span style="padding-top: 40px">选择的保函文本：</span>
                <upLoadImg
                  :idKey="4"
                  v-model="formModel.guaranteeDocumentExt"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-else :span="12">
            <el-form-item label="选择的保函文本">
              <div
                v-if="formModel.guaranteeDocument === '01'"
                style="
                  text-align: left;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                "
                @click="pdfBtn"
              >
                <img
                  style="width: 30px; height: 30px"
                  class="yulan_img"
                  src="../../assets/img/Pdf.png"
                  alt=""
                />
                <span
                  style="font-size: 14px; padding-left: 15px; color: #3d8bfc"
                  >保函文本（通用）点击预览</span
                >
              </div>
              <div
                v-if="formModel.guaranteeDocument === '02'"
                style="
                  text-align: left;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                "
                @click="pdfBtn"
              >
                <img
                  style="width: 30px; height: 30px"
                  class="yulan_img"
                  src="../../assets/img/Pdf.png"
                  alt=""
                />
                <span
                  v-if="formModel.guaranteeCategory === '02'"
                  style="font-size: 14px; padding-left: 15px; color: #3d8bfc"
                  >保函文本（独立-见索即付）点击预览</span
                >
                <span
                  v-else
                  style="font-size: 14px; padding-left: 15px; color: #3d8bfc"
                  >保函文本（独立）点击预览</span
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="formModel.status == '03' || formModel.status == '06'"
          >
            <el-form-item label="已开立保函：">
              <div
                style="
                  text-align: left;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                "
                @click="downClick"
              >
                <img
                  style="width: 30px; height: 30px"
                  src="../../assets/img/Pdf.png"
                  alt=""
                />
                <span
                  style="font-size: 14px; padding-left: 15px; color: #3d8bfc"
                  >点击下载</span
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中标通知书：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="5"
                  v-model="formModel.winBiderDocument"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招标文件：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="6"
                  v-model="formModel.bidDocument"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同：">
              <div class="uploadImageInner">
                <upLoadImg
                  :idKey="7"
                  v-model="formModel.bidContract"
                  :limit="upload.limit"
                  :viewImage="upload.viewImage"
                >
                </upLoadImg>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="我要给客服留言：">
              <span class="el_item_text">{{ formModel.remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: center; padding: 20px 0">
      <el-button
        style="width: 500px; height: 40px; font-size: 14px"
        type="primary"
        @click="gobidbond"
        >返回保函列表</el-button
      >
    </div>
    <el-dialog
      v-if="dialogVisibleEtplega"
      title=""
      :visible.sync="dialogVisibleEtplega"
      width="750px"
      :close-on-click-modal="false"
      custom-class="self-dialog"
    >
      <payMsg
        @childEditBtn="childEditBtn"
        :guaranteeId="guaranteeId"
        :guaranteePayMoney="formModel.guaranteePayMoney"
      ></payMsg>
    </el-dialog>
  </div>
</template>

<script>
import headPage from '@/components/head/index.vue'
import { getDetailZtb, getZtbPay, getPayOrderApi } from '@/api/adminData/index'
import { parseTime } from '@/utils/DateUtils'
import upLoadImg from '@/components/uploadImg/index.vue'
import uploadBtn from '@/components/uploadBtn/index.vue'
import { detailUpload, downloadFile } from '@/api/user/file'
import payMsg from '@/components/payMsg.vue'
import { desensitizeIdCard } from '@/utils/index'
export default {
  components: { upLoadImg, headPage, payMsg, uploadBtn },
  data() {
    return {
      dialogVisibleEtplega: false,
      dataLoading: false,
      formModel: {},
      upload: {
        limit: 1,
        viewImage: true
      },
      isPage: 1, //
      timer: null, // 定时器
      dialogVisible: false,
      radio: 0,
      guaranteeId: '',
      etpRA: {},
      payData: null,
      payType: '00' // 支付方式 00:二维码支付;01:企业网银在线支付
    }
  },
  mounted() {
    this.isPage = this.$route.query.isPage
      ? Number(this.$route.query.isPage)
      : 1
    this.guaranteeId = this.$route.query.guaranteeId

    this.getDetailData()
  },
  methods: {
    fixIdCard(v) {
      return desensitizeIdCard(v)
    },
    //下载保函
    downClick() {
      const data = {
        guid: this.formModel.returnGuarantee
      }
      this.dataLoading = true
      detailUpload(data).then((ress) => {
        this.dataLoading = false
        if (ress.success && ress.result) {
          console.log(ress.result)
          this.dataLoading = true
          downloadFile(data).then((res) => {
            this.dataLoading = false
            const content = res.data
            const blob = new Blob([content], { type: 'application/pdf' })
            const fileName = ress.result.fileName
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          })
        } else {
          this.$msgError('文件无效')
        }
      })
    },
    signUploadBtn() {
      this.$router.push({
        path: '/signUpload',
        query: {
          guaranteeId: this.formModel.guid
        }
      })
    },
    //申请发票
    applyInvoice() {
      this.$router.push({
        path: '/invoiceAdmin'
      })
    },
    getDetailData() {
      // 获取详情
      this.dataLoading = true
      getDetailZtb({ guaranteeId: this.guaranteeId }).then((res) => {
        this.dataLoading = false
        if (res.success) {
          // 企业信息
          this.formModel = res.result

          this.formModel = res.result
          this.formModel.etpCertBeginDate = parseTime(
            this.formModel.etpCertBeginDate,
            '{y}-{m}-{d}'
          )
          this.formModel.etpCertEndDate = parseTime(
            this.formModel.etpCertEndDate,
            '{y}-{m}-{d}'
          )
          this.formModel.bidEndDate = parseTime(
            this.formModel.bidEndDate,
            '{y}-{m}-{d}'
          )
          this.formModel.guaranteeBeginDate = parseTime(
            this.formModel.guaranteeBeginDate,
            '{y}-{m}-{d}'
          )
          this.formModel.guaranteeEndDate = parseTime(
            this.formModel.guaranteeEndDate,
            '{y}-{m}-{d}'
          )
          this.formModel.created = parseTime(
            this.formModel.created,
            '{y}-{m}-{d} {h}:{i}:{s}'
          )
          this.formModel.etpLegalIdcardDateBegin = parseTime(
            this.formModel.etpLegalIdcardDateBegin,
            '{y}-{m}-{d}'
          )
          this.formModel.etpLegalIdcardDateEnd = parseTime(
            this.formModel.etpLegalIdcardDateEnd,
            '{y}-{m}-{d}'
          )
        } else {
          this.$message.error(res.message)
        }
        this.contentLoading = false
      })
    },
    etplegaPayClick() {
      // 提交付款凭证
      this.dialogVisibleEtplega = true
    },
    childEditBtn() {
      this.dialogVisibleEtplega = false
      this.getDetailData()
    },
    gobidbond() {
      this.$router.push('/bidBondAdmin')
    },
    pdfBtn() {
      switch (this.formModel.guaranteeCategory) {
        case '01':
          if (this.formModel.guaranteeDocument == '01') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/tb-common.pdf',
              '_blank'
            )
          } else if (this.formModel.guaranteeDocument == '02') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/tb-alone-guarantee.pdf',
              '_blank'
            )
          }
          break
        case '02':
          if (this.formModel.guaranteeDocument == '01') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-ly-common.pdf',
              '_blank'
            )
          } else if (this.formModel.guaranteeDocument == '02') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-ly-jsjf.pdf',
              '_blank'
            )
          }
          break
        case '03':
          if (this.formModel.guaranteeDocument == '01') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-zl-common.pdf',
              '_blank'
            )
          } else if (this.formModel.guaranteeDocument == '02') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-zl-alone.pdf',
              '_blank'
            )
          }
          break
        case '04':
          if (this.formModel.guaranteeDocument == '01') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-yfk-common.pdf',
              '_blank'
            )
          } else if (this.formModel.guaranteeDocument == '02') {
            window.open(
              'https://api.yinbaobiao.com/web/ybb/upload/document-doc/guarantee-doc-yfk-alone.pdf',
              '_blank'
            )
          }
          break
      }
    },
    formatCurrency(number) {
      // 将数字转换为字符串并去除小数点前两位之前的0
      const numberStr = number.toFixed(2).replace(/^0+/, '')
      // 使用正则表达式将每三个数字分隔
      const formatted = numberStr.replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        '$&,'
      )
      // 如果小数部分为00，则去除小数点和零
      return formatted.replace(/,\d{2}$/, '')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0;
}

.optButton {
  line-height: 10px;
}
.applyFor {
  width: 1200px;
  margin: 0 auto;
}
.uploadImageInner {
  margin: -18px 0 0 100px;
  line-height: 10px;
}
::v-deep .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 0 0;
}

.el_item_text {
  color: #000;
}

.red {
  color: #f00 !important;
}
.left_title {
  width: 1200px;
  margin: 20px auto;
  span {
    cursor: pointer;
    color: #3d8bfc;
  }
}
.applyFor {
  ::v-deep .djsc_btn {
    display: none;
  }
}
</style>
